import { emptyValidator, formValidator } from "../../validators";

// {
//     ncrCompany,
//     ncrProjectName,
//     ncrReportedBy,
//     ncrReportedDate,
//     ncrCustomerComplaint,
//     ncrMadeVia,
//     ncrType,
//     ncrCustomer,
//     ncrCustomerName: ncrCustomerName,
//     ncrEmail,
//     ncrPhone,
//     ncrSeverity,
//     ncrConcernReported: ncrReportedConcern,
//     ncrCause,
//     ncrImmAction,
//     ncrImmBy,
//     ncrImmDate,
//     ncrCorrAction,
//     ncrCorrBy,
//     ncrCorrDate,
//     ncrPreAction: ncrPrvAction,
//     ncrPreBy,
//     ncrPreDate,
//     ncrFinalOutcome,
//     ncrFeedbackGiven,
//     ncrFeedbackReevaluation,
//     ncrReevaluationDate,
//     ncrSeq: 1,
//     ncrStatus,
//     ncrActive,
//     ncrReqId: reqId,
//     ncrReqCode: reqCode,
//     author: user.username,
//   };

const ncrValidationStatus = {
  ncrProjectName: {
    validators: [emptyValidator()],
    name: "Project Name",
  },
  ncrReportedBy: {
    validators: [emptyValidator()],
    name: "Reported By",
  },
  ncrReportedDate: {
    validators: [emptyValidator()],
    name: "Reported Date",
  },
  ncrCustomerComplaint: {
    validators: [emptyValidator()],
    name: "Customer Complaint",
  },
  ncrMadeVia: {
    validators: [emptyValidator()],
    name: "Made Via",
  },
  ncrType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  ncrCustomer: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  ncrEmail: {
    validators: [emptyValidator()],
    name: "Email",
  },
  ncrPhone: {
    validators: [emptyValidator()],
    name: "Phone",
  },
  ncrSeverity: {
    validators: [emptyValidator()],
    name: "Severity",
  },
  ncrConcernReported: {
    validators: [emptyValidator()],
    name: "Concern Reported",
  },
  ncrCause: {
    validators: [emptyValidator()],
    name: "Cause",
  },
  ncrImmAction: {
    validators: [emptyValidator()],
    name: "Immediate Action",
  },
  ncrImmBy: {
    validators: [emptyValidator()],
    name: "Immediate By",
  },
  ncrImmDate: {
    validators: [emptyValidator()],
    name: "Immediate Date",
  },
  ncrCorrAction: {
    validators: [emptyValidator()],
    name: "Corrective Action",
  },
  ncrCorrBy: {
    validators: [emptyValidator()],
    name: "Corrective By",
  },
  ncrCorrDate: {
    validators: [emptyValidator()],
    name: "Corrective Date",
  },
  ncrPreAction: {
    validators: [emptyValidator()],
    name: "Preventive Action",
  },
  ncrPreBy: {
    validators: [emptyValidator()],
    name: "Preventive By",
  },
  ncrPreDate: {
    validators: [emptyValidator()],
    name: "Preventive Date",
  },
  ncrFinalOutcome: {
    validators: [emptyValidator()],
    name: "Final Outcome",
  },
  ncrFeedbackGiven: {
    validators: [emptyValidator()],
    name: "Feedback Given",
  },
  ncrFeedbackReevaluation: {
    validators: [emptyValidator()],
    name: "Feedback Reevaluation",
  },
  ncrReevaluationDate: {
    validators: [emptyValidator()],
    name: "Reevaluation Date",
  },
  ncrSeq: {
    validators: [emptyValidator()],
    name: "Seq",
  },
  ncrStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  ncrActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const ncrFormValidator = (ncr) => {
  return formValidator(ncr, ncrValidationStatus);
};
